
function replaceInputByWrongAnswer(answerInput) {
  const wrongAnswer = document.createElement('span');
  wrongAnswer.textContent = answerInput.value;
  wrongAnswer.classList.add('wrong-answer');
  answerInput.replaceWith(wrongAnswer);
}

function displayCorrection(correction) {
  correction.classList.remove('correction');
  correction.classList.add('correction-visible');
}

function isCorrectAnswer(answerInput, correction) {
  return answerInput.value.trim() === correction.textContent.trim();
}

function replaceInputByCorrectAnswer(answerInput) {
  const correctAnswer = document.createElement('span');
  correctAnswer.textContent = answerInput.value;
  correctAnswer.classList.add('correct-answer');
  answerInput.replaceWith(correctAnswer);
}

export const writingPracticeSubmit = () => {

  // Locate the container where the injected HTML is rendered.
  const container = document.querySelector('.page-content');
  if (!container) return;

  // Find the submit button within the form.
  const submitButton = container.querySelector('form.write-form button[type="button"]');
  if (!submitButton) return;

  const handleSubmit = () => {

    const hiddenInputs = container.querySelectorAll('.hidden-input');
    hiddenInputs.forEach(span => {

      const answerInput = span.querySelector('input.answer');
      const correction = span.querySelector('span.correction');

      if (answerInput && correction) {
        if (isCorrectAnswer(answerInput, correction)) {
          replaceInputByCorrectAnswer(answerInput);
        }
        else {
          replaceInputByWrongAnswer(answerInput);
          displayCorrection(correction);
        }
      }

    });
  };

  // Attach the event listener.
  submitButton.addEventListener('click', handleSubmit);

  // Return a cleanup function to remove the event listener.
  return () => {
    submitButton.removeEventListener('click', handleSubmit);
  };
};
